import request from '@/utils/request'


// 获取人脸闸机列表
export function getHistoryList(params) {
  return request.get('/personAccess/list', { params })
}

// 人脸闸机放行
export function updateOne(params) {
  return request.get('/equip/openDoor', { params })
}

